import {
	ObjectChange,
	ObjectChangeType,
	ReactiveChange,
	ReactiveChangeType,
} from "./reactive-plugin";

/**
 * Generates a list of change descriptions for an object set operation.
 * This function is intended to be called when a property is set on an object.
 *
 * @param object The reactive object proxy.
 * @param property The property key (string or symbol) being set.
 * @param previousValue The value of the property *before* the set operation.
 * @param nextValue The new value being set for the property.
 * @returns An array of ReactiveChange objects, or null if no reportable changes occurred (though current implementation always returns a change).
 */
export const getObjectSetChanges = (
	object: object,
	property: string | symbol,
	previousValue: unknown,
	nextValue: unknown
): ReactiveChange[] | null => {
	const objectChange: ObjectChange = {
		type: ObjectChangeType.SetProperty,
		property,
		previousValue,
		nextValue,
	};

	return [
		{
			type: ReactiveChangeType.Object,
			object,
			objectChange,
		},
	];
};

/**
 * Generates a list of change descriptions for an object delete operation.
 * This function is intended to be called when a property is deleted from an object.
 *
 * @param object The reactive object proxy.
 * @param property The property key (string or symbol) being deleted.
 * @param previousValue The value of the property *before* the delete operation.
 * @returns An array of ReactiveChange objects, or null if no reportable changes occurred (though current implementation always returns a change).
 */
export const getObjectDeleteChanges = (
	object: object,
	property: string | symbol,
	previousValue: unknown
): ReactiveChange[] | null => {
	const objectChange: ObjectChange = {
		type: ObjectChangeType.DeleteProperty,
		property,
		previousValue,
	};

	return [
		{
			type: ReactiveChangeType.Object,
			object,
			objectChange,
		},
	];
};
